import { render } from "./ZkpView.vue?vue&type=template&id=b6aa6a4a"
import script from "./ZkpView.vue?vue&type=script&lang=js"
export * from "./ZkpView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__